import { render, staticRenderFns } from "./noticeList.vue?vue&type=template&id=cf4d7620&scoped=true&"
import script from "./noticeList.vue?vue&type=script&lang=js&"
export * from "./noticeList.vue?vue&type=script&lang=js&"
import style0 from "./noticeList.vue?vue&type=style&index=0&id=cf4d7620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4d7620",
  null
  
)

export default component.exports